import React, { useEffect, useState } from "react";
import api from "utils/axiosInstance";
import formatMinutes from "utils/formatMinutes";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Collapse } from "@mui/material";
import { Button } from "react-bootstrap";

const TABLE_HEADERS = [
  "User ID",
  "Randomization",
  "Week Number",
  "Dates",
  "Time Spent",
];

export function UserTrackingDetails({ userId }) {
  const [timeSpentData, setTimeSpentData] = useState([]);
  const [error, setError] = useState({ state: false, message: "" });

  useEffect(() => {
    (async function () {
      const timeSpentDataResponse = await getTimespentData();
      if (timeSpentDataResponse !== null)
        setTimeSpentData(
          timeSpentDataResponse.map((data, idx) => ({
            id: idx,
            ...data,
            timeSpent: formatMinutes(data.totalTimeSpent),
            randomization:
              data.randomization === 2
                ? "HRVB"
                : data.randomization === 1
                ? "EDU"
                : "Unknown",
          }))
        );
    })();
  }, [userId]);

  async function getTimespentData() {
    try {
      const timeSpentRes = await api({
        method: "get",
        url: `/User/tracking/${userId}`,
      });
      return timeSpentRes.data;
    } catch (err) {
      if (err.response && err.response.data) {
        setError({
          state: true,
          message:
            (err.response && err.response.data.message) ||
            "An Unknown error occured",
        });
      }
    }
  }

  async function exportHandler() {
    if (timeSpentData.length === 0) return;

    const headers = [
      "userId",
      "weekNumber",
      "totalTimeSpent",
      "datesIncluded",
      "randomization",
      "timeSpent",
    ];
    const rows = timeSpentData.map(({ id, ...rest }) =>
      Object.values(rest)
        .map((value) => `"${value}"`)
        .join(",")
    );

    const csvContent = [headers, ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `UserTrackingDetails - ${new Date().toLocaleDateString("en-US")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <TableRow>
        <TableCell colSpan={5}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                {TABLE_HEADERS.map((el) => (
                  <TableCell>{el}</TableCell>
                ))}
                <TableCell>
                  <Button onClick={exportHandler}>Export Details</Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSpentData &&
                timeSpentData
                  .sort((a, b) => a.weekNumber - b.weekNumber)
                  .map((data) => (
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>{data.userId}</TableCell>
                      <TableCell>{data.randomization}</TableCell>
                      <TableCell>{data.weekNumber}</TableCell>

                      <TableCell>{data.datesIncluded}</TableCell>
                      <TableCell>
                        {formatMinutes(data.totalTimeSpent)}
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableCell>
      </TableRow>
    </>
  );
}
